import {AuthService} from "./core/services/auth.service";

export function appInitializerFactory(authService:AuthService): () => Promise<any> {
    return (): Promise<any> => {
        return authService.initLogin();
    };
}
